export function cloneDialog(texts, method) {
  const { title, subtitle, confirm } = texts
  const template = document.getElementById("turbo-confirm");
  const dialog = template.content.cloneNode(true);

  const dialogElement = dialog.querySelector("dialog")

  dialog.querySelector("[data-turbo-message=title]").innerText = title;
  dialog.querySelector("[data-turbo-message=subtitle]").innerHTML =
    subtitle;

  const buttons = dialog.querySelectorAll("[data-behavior=confirm]");
  const confirmButton = Array.from(buttons).find(
    (button) => button.dataset.method === method,
  );
  confirmButton.disabled = false;

  if (confirm) {
    confirmButton.innerText = confirm;
  }

  return { dialog, dialogElement, confirmButton };
}
